import React, { useLayoutEffect } from 'react';
import FadeInSection from '../components/FadeInSection';
import '../styles/Testimonials.scss';
import { Helmet } from 'react-helmet-async';
import TestimonialsColumns from './TestimonialsColumns';

function Testimonials() {
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>Client Reviews | Lily Lai Real Estate</title>
        <meta name="description" content="See what buyers and sellers across the Bay Area are saying about working with Lily Lai. Real stories, real results — from San Francisco to the Peninsula." />
        <link rel="canonical" href="https://www.lilylaisf.com/testimonials" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.lilylaisf.com/testimonials" />
        <meta property="og:title" content="Client Reviews | Lily Lai Real Estate" />
        <meta property="og:description" content="Real stories from buyers and sellers across the Bay Area who worked with Lily Lai." />
        <meta property="og:image" content="https://res.cloudinary.com/dlaituqwq/image/upload/f_auto,q_auto/a2du5a8knn9k8uqo8jom" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Client Reviews | Lily Lai Real Estate" />
        <meta name="twitter:description" content="Real stories from buyers and sellers across the Bay Area who worked with Lily Lai." />
        <meta name="twitter:image" content="https://res.cloudinary.com/dlaituqwq/image/upload/f_auto,q_auto/a2du5a8knn9k8uqo8jom" />
        <script type="application/ld+json">{`
          {
            "@context": "https://schema.org",
            "@type": "RealEstateAgent",
            "name": "Lily Lai Real Estate",
            "url": "https://www.lilylaisf.com",
            "aggregateRating": {
              "@type": "AggregateRating",
              "ratingValue": "5",
              "reviewCount": "38",
              "bestRating": "5",
              "worstRating": "1"
            },
            "review": [
              {
                "@type": "Review",
                "author": { "@type": "Person", "name": "Eric C." },
                "reviewRating": { "@type": "Rating", "ratingValue": "5", "bestRating": "5" },
                "reviewBody": "5 stars for Lily. As a first-time homebuyer, Lily walked my brother and I through the entire process. She was very straightforward, responsive, patient, and delightful to work with. Her knowledge of the real estate market really helped us make informed decisions and stand by our decisions with confidence."
              },
              {
                "@type": "Review",
                "author": { "@type": "Person", "name": "Anna Z." },
                "reviewRating": { "@type": "Rating", "ratingValue": "5", "bestRating": "5" },
                "reviewBody": "Lily sold my home under the most challenging of circumstances in a market unfavorable towards sellers. She skillfully navigated every obstacle and secured the best price possible. Lily is an agent who will go above and beyond for her clients."
              },
              {
                "@type": "Review",
                "author": { "@type": "Person", "name": "Brooke M." },
                "reviewRating": { "@type": "Rating", "ratingValue": "5", "bestRating": "5" },
                "reviewBody": "I worked with Lily as both a first-time buyer and seller. She helped me find the perfect condo and later helped me sell above listing price. Her exceptional communication skills stood out — always prompt and keeping me informed every step of the way."
              },
              {
                "@type": "Review",
                "author": { "@type": "Person", "name": "Christine L." },
                "reviewRating": { "@type": "Rating", "ratingValue": "5", "bestRating": "5" },
                "reviewBody": "Lily helped me achieve what I thought was an impossible pipe dream — owning a condo in my dream neighborhood within my budget in one of the most competitive markets in the country. She displayed incredible patience, empathy, and encouragement throughout."
              },
              {
                "@type": "Review",
                "author": { "@type": "Person", "name": "Justin H." },
                "reviewRating": { "@type": "Rating", "ratingValue": "5", "bestRating": "5" },
                "reviewBody": "Lily is an amazing and genuinely caring realtor who helped us find our dream home. As first-time homebuyers, she made everything feel far less overwhelming and much easier to understand. Lily is an invaluable resource and we highly recommend her to anyone looking for a realtor in the SF Bay Area."
              },
              {
                "@type": "Review",
                "author": { "@type": "Person", "name": "Sahar B." },
                "reviewRating": { "@type": "Rating", "ratingValue": "5", "bestRating": "5" },
                "reviewBody": "Lily was an amazing agent who came to my rescue when I hit multiple roadblocks selling my house. Once I hired her, a house that was sitting on the market for more than 6 weeks sold within 2 weeks. I really appreciate Lily and absolutely recommend her as an agent."
              },
              {
                "@type": "Review",
                "author": { "@type": "Person", "name": "Lillian K." },
                "reviewRating": { "@type": "Rating", "ratingValue": "5", "bestRating": "5" },
                "reviewBody": "Lily and Bryant are truly godsends. I cannot imagine how we could have landed our first home, in a competitive market like San Francisco, without our amazing partnership with them. They made every single granular step concrete and clear for us."
              },
              {
                "@type": "Review",
                "author": { "@type": "Person", "name": "Teresa Y." },
                "reviewRating": { "@type": "Rating", "ratingValue": "5", "bestRating": "5" },
                "reviewBody": "As first-time home buyers, we were lucky to have Lily as our agent. She took the time to explain the market basics, helped us navigate unique situations with our best interests in mind, and provided insights from her experience. I valued her input from both a financial/market perspective and from a renovating/design standpoint."
              }
            ]
          }
        `}</script>
      </Helmet>

      <div className="testimonials">

        {/* ── Scrolling columns hero ─────────────────────────────────────────── */}
        <FadeInSection>
          <div className="tc-hero">
            <div className="tc-hero-badge">Client Reviews</div>
            <h1 className="tc-hero-title">What Clients Are Saying</h1>
            <p className="tc-hero-sub">Real stories from buyers and sellers across the Bay Area.</p>
          </div>
        </FadeInSection>

        <TestimonialsColumns />

      </div>
    </>
  );
}

export default Testimonials;
